// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nh1[data-v-e899811a] {\n  font-size: 30px;\n  font-weight: bold;\n}\n.instert-by-range[data-v-e899811a] {\n  padding: 20px;\n  margin: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
